import React from "react";
import { config } from "../../../../../config";

const UpdateCta = ({ formData, setFormData, handleChange, handleSubmit, onCancel, loading, error }) => {
  return (
    <div className="p-6 max-w-lg mx-auto bg-white shadow rounded">
      <h2 className="text-2xl font-bold mb-4">Update Call To Action</h2>

      {loading && <p className="text-blue-500 mb-4">Updating...</p>}
      {error && <p className="text-red-500 mb-4">{error}</p>}

      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-gray-700 font-medium">Slug</label>
          <input
            type="text"
            name="slug"
            value={formData.slug}
            onChange={handleChange}
            className="border w-full p-2"
            placeholder="e.g., home-page-cta"
            required
          />
        </div>

        <div>
          <label className="block text-gray-700 font-medium">Title</label>
          <input
            type="text"
            name="title"
            value={formData.title}
            onChange={handleChange}
            className="border w-full p-2"
            placeholder="e.g., Ready to get started?"
            required
          />
        </div>

        <div>
          <label className="block text-gray-700 font-medium">Description</label>
          <textarea
            name="description"
            value={formData.description}
            onChange={handleChange}
            className="border w-full p-2"
            rows="3"
            placeholder="Enter a compelling description..."
            required
          ></textarea>
        </div>

        <div>
          <label className="block text-gray-700 font-medium">Button Text</label>
          <input
            type="text"
            name="button_text"
            value={formData.button_text}
            onChange={handleChange}
            className="border w-full p-2"
            placeholder="e.g., Get Started Now"
            required
          />
        </div>

        <div>
          <label className="block text-gray-700 font-medium">Button Link</label>
          <input
            type="url"
            name="button_link"
            value={formData.button_link}
            onChange={handleChange}
            className="border w-full p-2"
            placeholder="e.g., https://example.com/signup"
            required
          />
        </div>

         <div className="flex justify-end space-x-3">
             <button
              type="button"
              onClick={onCancel}
              className="bg-gray-500 text-white px-6 py-2 rounded hover:bg-gray-600"
              disabled={loading}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
              disabled={loading}
            >
              {loading ? "Updating..." : "Update CTA"}
            </button>
        </div>

    
      </form>
    </div>
  );
};

export default UpdateCta;